import finishFlagUrl from 'images/icons/finish_flag.svg'
import React, { useMemo } from 'react'
import { CircleLayer, Layer, Source, SymbolLayer, useControl } from 'react-map-gl'
import { DEFAULT_VIZUALIZATION_SETTINGS } from 'utils/constants'
import { IPoint } from 'utils/interfaces'

const cleaningRouteFinishPointStyle1: any = {
  id: 'mission-finish-point1',
  type: 'circle',
  paint: {
    'circle-radius': 9,
    'circle-color': '#ef4444', // Red for finish
    'circle-stroke-width': 1,
    'circle-stroke-color': 'white',
  },
}

const cleaningRouteFinishPointStyle2: any = {
  id: 'mission-finish-point2',
  type: 'circle',
  paint: {
    'circle-radius': 7,
    'circle-color': 'white',
  },
}

const cleaningRouteFinishPointStyle3: any = {
  id: 'mission-finish-point3',
  type: 'circle',
  paint: {
    'circle-radius': 4,
    'circle-color': '#ef4444',
  },
}

// launch point
const cleaningRouteLaunchPointStyle1: any = {
  id: 'mission-start-point',
  type: 'circle',
  paint: {
    'circle-radius': 9,
    'circle-color': '#10b981', // Green for start
    'circle-stroke-width': 1,
    'circle-stroke-color': 'white',
  },
}

const cleaningRouteLaunchPointStyle2: any = {
  id: 'mission-start-point-center',
  type: 'circle',
  paint: {
    'circle-radius': 4,
    'circle-color': 'white',
  },
}

const MissionStartFinishPoints = ({
  startPoint,
  finishPoint,
  startPoints,
  finishPoints,
  beforeId,
}: {
  startPoint?: IPoint
  finishPoint?: IPoint
  startPoints?: (IPoint | undefined)[]
  finishPoints?: (IPoint | undefined)[]
  beforeId?: string
}) => {
  const allStartPoints = useMemo(() => {
    const pts = [...(startPoints || [])]
    if (startPoint) pts.push(startPoint)
    return pts.filter(Boolean) as IPoint[]
  }, [startPoint, startPoints])

  const allFinishPoints = useMemo(() => {
    const pts = [...(finishPoints || [])]
    if (finishPoint) pts.push(finishPoint)
    return pts.filter(Boolean) as IPoint[]
  }, [finishPoint, finishPoints])

  const startData = useMemo(
    () => ({
      type: 'FeatureCollection',
      features: allStartPoints,
    }),
    [allStartPoints]
  )

  const finishData = useMemo(
    () => ({
      type: 'FeatureCollection',
      features: allFinishPoints,
    }),
    [allFinishPoints]
  )

  return (
    <>
      {allStartPoints.length > 0 && (
        <Source id="mission-start-point" type="geojson" data={startData as any}>
          <Layer {...cleaningRouteLaunchPointStyle1} source="mission-start-point" beforeId={beforeId} />
          <Layer {...cleaningRouteLaunchPointStyle2} source="mission-start-point" beforeId={beforeId} />
        </Source>
      )}
      {allFinishPoints.length > 0 && (
        <Source id="mission-finish-point" type="geojson" data={finishData as any}>
          <Layer {...cleaningRouteFinishPointStyle1} source="mission-finish-point" beforeId={beforeId} />
          <Layer {...cleaningRouteFinishPointStyle2} source="mission-finish-point" beforeId={beforeId} />
          <Layer {...cleaningRouteFinishPointStyle3} source="mission-finish-point" beforeId={beforeId} />
        </Source>
      )}
    </>
  )
}

export default MissionStartFinishPoints
